(function() {
  const root = document.querySelector('[data-searchanise-header]');
  if (!root) return;

  const body = document.body;
  const toggle = root.querySelector('.searchanise-toggle');
  const bar = root.querySelector('.searchanise-bar');
  const input = root.querySelector('.searchanise-bar input[name="q"]');
  const closeBtn = root.querySelector('[data-searchanise-close]');

  var queryCheckInterval;
  var pendingSnizeOpen = false;
  var snizePendingObserver = null;
  var snizePendingTimeoutId = null;
  var awaitingSnizeMount = false;
  var awaitingMountPollId = null;
  var snizeMountMo = null;
  var clearObserver = null;
  var suppressOutsideCloseUntil = 0;
  var lastResizeInnerWidth = window.innerWidth;

  function isSearchUiOpen() {
    return body.classList.contains('searchanise-bar-open') || body.classList.contains('snize-instant-widget-is-open');
  }

  function clickEventInsideSnizeOverlay(e) {
    if (e.target && e.target.closest && e.target.closest('#snize-instant-search-results')) return true;
    if (typeof e.composedPath !== 'function') return false;
    var path = e.composedPath();
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || el.nodeType !== 1) continue;
      if (el.id === 'snize-instant-search-results') return true;
      if (el.classList && el.classList.contains('snize-ac-results-mobile')) return true;
    }
    return false;
  }

  function stopAwaitingMountPoll() {
    if (awaitingMountPollId) {
      clearInterval(awaitingMountPollId);
      awaitingMountPollId = null;
    }
  }

  function disconnectSnizeMountObserver() {
    if (snizeMountMo) {
      snizeMountMo.disconnect();
      snizeMountMo = null;
    }
  }

  function stopAwaitingFlow() {
    stopAwaitingMountPoll();
    disconnectSnizeMountObserver();
  }

  function connectSnizeMountObserverWhileAwaiting() {
    disconnectSnizeMountObserver();
    if (!awaitingSnizeMount) return;
    snizeMountMo = new MutationObserver(function() {
      flushAwaitingOpenIfMounted();
    });
    snizeMountMo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function setAwaitingChrome(on) {
    body.classList.toggle('searchanise-awaiting-snize', !!on);
    if (toggle) {
      if (on) toggle.setAttribute('aria-busy', 'true');
      else toggle.removeAttribute('aria-busy');
    }
  }

  function cancelAwaitingScript() {
    awaitingSnizeMount = false;
    stopAwaitingFlow();
    setAwaitingChrome(false);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function navigateToSearch() {
    if (toggle && toggle.href) window.location.assign(toggle.href);
  }

  function isSearchaniseMounted() {
    var el = document.getElementById('snize-instant-search-results');
    if (!el || !el.classList.contains('snize-new-design')) return false;
    return el.classList.contains('snize-ac-results') || el.classList.contains('snize-ac-results-mobile');
  }

  function flushAwaitingOpenIfMounted() {
    if (!awaitingSnizeMount || !isSearchaniseMounted()) return;
    awaitingSnizeMount = false;
    stopAwaitingFlow();
    setAwaitingChrome(false);
    applyOpen();
  }

  function beginAwaitingMountPoll() {
    stopAwaitingFlow();
    connectSnizeMountObserverWhileAwaiting();
    flushAwaitingOpenIfMounted();
    var steps = 0;
    awaitingMountPollId = setInterval(function() {
      flushAwaitingOpenIfMounted();
      if (!awaitingSnizeMount) {
        stopAwaitingMountPoll();
        return;
      }
      if (++steps > 40) {
        stopAwaitingMountPoll();
        if (awaitingSnizeMount) {
          cancelAwaitingScript();
          navigateToSearch();
        }
      }
    }, 150);
  }

  function disconnectSnizePendingWatch() {
    if (snizePendingObserver) {
      snizePendingObserver.disconnect();
      snizePendingObserver = null;
    }
    if (snizePendingTimeoutId) {
      clearTimeout(snizePendingTimeoutId);
      snizePendingTimeoutId = null;
    }
  }

  function focusDesktopSearchInput() {
    if (!input || window.matchMedia('(max-width: 768px)').matches) return;
    function tryFocus() {
      input.focus({ preventScroll: true });
    }
    if (toggle && document.activeElement === toggle) toggle.blur();
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        tryFocus();
        if (document.activeElement !== input) setTimeout(tryFocus, 50);
        if (document.activeElement !== input) setTimeout(tryFocus, 320);
      });
    });
  }

  function connectClearObserver() {
    if (clearObserver) return;
    clearObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (mutations[i].attributeName === 'class' && target.classList && target.classList.contains('snize-clear-button') && target.classList.contains('snize-icon-search')) {
          clearAllSearchInputs();
          forceShowSuggestions();
          runForceShowLoop();
          break;
        }
      }
    });
    clearObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function disconnectClearObserver() {
    if (clearObserver) {
      clearObserver.disconnect();
      clearObserver = null;
    }
  }

  function applyOpen() {
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (mobile) {
      body.classList.remove('searchanise-bar-open');
      body.classList.remove('searchanise-input-active');
      body.classList.remove('searchanise-has-query');
      body.classList.add('snize-instant-widget-is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (bar) bar.setAttribute('aria-hidden', 'true');
      suppressOutsideCloseUntil = Date.now() + 550;
      connectClearObserver();
      var snizeMobileInput = document.getElementById('snize-mobile-search-input');
      if (snizeMobileInput) {
        setTimeout(function() { snizeMobileInput.focus({ preventScroll: true }); }, 0);
      }
      return;
    }
    body.classList.add('searchanise-bar-open');
    body.classList.remove('searchanise-input-active');
    body.classList.remove('snize-instant-widget-is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (bar) bar.setAttribute('aria-hidden', 'false');
    queryCheckInterval = setInterval(updateHasQuery, 150);
    connectClearObserver();
    maybeQueueSnizePending();
    focusDesktopSearchInput();
  }

  function requestOpen() {
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (mobile) {
      if (isSearchaniseMounted()) {
        applyOpen();
        return;
      }
      awaitingSnizeMount = true;
      setAwaitingChrome(true);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      beginAwaitingMountPoll();
      return;
    }
    if (isSearchaniseMounted()) {
      applyOpen();
      return;
    }
    applyOpen();
  }

  function close() {
    suppressOutsideCloseUntil = 0;
    awaitingSnizeMount = false;
    stopAwaitingFlow();
    setAwaitingChrome(false);
    pendingSnizeOpen = false;
    disconnectSnizePendingWatch();
    disconnectClearObserver();
    if (queryCheckInterval) {
      clearInterval(queryCheckInterval);
      queryCheckInterval = null;
    }
    if (input) {
      input.blur();
      input.value = '';
    }
    body.classList.remove('searchanise-bar-open');
    body.classList.remove('searchanise-input-active');
    body.classList.remove('searchanise-has-query');
    body.classList.remove('snize-instant-widget-is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (bar) bar.setAttribute('aria-hidden', 'true');
    var snize = document.getElementById('snize-instant-search-results');
    if (snize) snize.style.setProperty('display', 'none', 'important');
  }

  function maybeQueueSnizePending() {
    if (window.matchMedia('(max-width: 768px)').matches) return;
    if (isSearchaniseMounted()) return;
    pendingSnizeOpen = true;
    startSnizePendingWatch();
  }

  function completePendingSnizeOpen() {
    pendingSnizeOpen = false;
    disconnectSnizePendingWatch();
    if (!isSearchUiOpen()) return;
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var snizeMobile = document.getElementById('snize-mobile-search-input');
    if (mobile && snizeMobile) {
      snizeMobile.focus({ preventScroll: true });
    } else {
      focusDesktopSearchInput();
    }
    updateHasQuery();
    forceShowSuggestions();
    runForceShowLoop();
  }

  function startSnizePendingWatch() {
    disconnectSnizePendingWatch();
    if (!pendingSnizeOpen) return;
    if (isSearchaniseMounted()) {
      completePendingSnizeOpen();
      return;
    }
    snizePendingObserver = new MutationObserver(function() {
      if (!pendingSnizeOpen || !isSearchUiOpen()) {
        disconnectSnizePendingWatch();
        return;
      }
      if (isSearchaniseMounted()) completePendingSnizeOpen();
    });
    snizePendingObserver.observe(document.body, { childList: true, subtree: true });
    snizePendingTimeoutId = setTimeout(function() {
      if (pendingSnizeOpen) {
        pendingSnizeOpen = false;
        disconnectSnizePendingWatch();
      }
    }, 45000);
  }

  function updateHasQuery() {
    var searchInputs = document.querySelectorAll('input[name="q"], #snize-mobile-search-input, #snize-instant-search-results input[type="search"], #snize-instant-search-results input[type="text"]');
    var hasQuery = false;
    for (var i = 0; i < searchInputs.length; i++) {
      if (searchInputs[i].value.trim().length > 0) {
        hasQuery = true;
        break;
      }
    }
    if (body.classList.contains('searchanise-bar-open')) {
      var clearAsSearch = document.querySelector('.snize-clear-button.snize-icon-search');
      if (clearAsSearch && getComputedStyle(clearAsSearch).visibility !== 'hidden') hasQuery = false;
    }
    if (hasQuery) body.classList.add('searchanise-has-query');
    else {
      body.classList.remove('searchanise-has-query');
      if (body.classList.contains('searchanise-bar-open')) {
        body.classList.add('searchanise-input-active');
        var suggestions = document.getElementById('snize-ac-items-container-1');
        if (suggestions) suggestions.style.removeProperty('display');
        if (input && document.activeElement === input) {
          input.blur();
          input.focus();
        }
      }
    }
  }

  if (input) {
    input.addEventListener('focus', function() {
      if (body.classList.contains('searchanise-bar-open')) {
        body.classList.add('searchanise-input-active');
      }
    });
    input.addEventListener('input', updateHasQuery);
    input.addEventListener('change', updateHasQuery);
  }

  document.addEventListener('input', function(e) {
    if (e.target && (e.target.name === 'q' || e.target.id === 'snize-mobile-search-input' || (e.target.closest && e.target.closest('#snize-instant-search-results')))) {
      updateHasQuery();
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target && (e.target.name === 'q' || e.target.id === 'snize-mobile-search-input' || (e.target.closest && e.target.closest('#snize-instant-search-results')))) {
      updateHasQuery();
    }
  });

  if (toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isSearchUiOpen()) close();
      else if (!awaitingSnizeMount) requestOpen();
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (input && input.value.trim() !== '') {
      input.value = '';
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      close();
    }
  });

  var searchInputSelector = 'input[name="q"], #snize-mobile-search-input, #snize-instant-search-results input[type="search"], #snize-instant-search-results input[type="text"]';

  function clearAllSearchInputs() {
    var inputs = document.querySelectorAll(searchInputSelector);
    for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
  }

  function forceShowSuggestions() {
    body.classList.add('searchanise-input-active');
    body.classList.remove('searchanise-has-query');
    var suggestions = document.getElementById('snize-ac-items-container-1');
    if (suggestions) suggestions.style.removeProperty('display');
    if (input) input.focus();
  }

  function runForceShowLoop() {
    forceShowSuggestions();
    requestAnimationFrame(function() {
      setTimeout(forceShowSuggestions, 0);
    });
  }

  function onClearButtonAction() {
    if (!isSearchUiOpen()) return;
    clearAllSearchInputs();
    updateHasQuery();
    forceShowSuggestions();
    runForceShowLoop();
  }

  function isClearButton(e) {
    var el = e.target;
    if (!el || !el.closest) return false;
    var container = el.closest('.snize-clear-button-container');
    if (!container) return false;
    var btn = container.querySelector('.snize-clear-button');
    return btn && !btn.classList.contains('snize-icon-search');
  }

  document.addEventListener('click', function(e) {
    if (isClearButton(e)) onClearButtonAction();
  }, true);

  document.addEventListener('touchstart', function(e) {
    if (isClearButton(e)) onClearButtonAction();
  }, true);

  (function observeMobileInput() {
    var bodyObserver = new MutationObserver(function() {
      var mobileInput = document.getElementById('snize-mobile-search-input');
      if (!mobileInput || mobileInput._snizeObserved) return;
      mobileInput._snizeObserved = true;
      mobileInput.addEventListener('input', updateHasQuery);
      mobileInput.addEventListener('change', updateHasQuery);
      bodyObserver.disconnect();
    });
    var mobileInput = document.getElementById('snize-mobile-search-input');
    if (mobileInput && !mobileInput._snizeObserved) {
      mobileInput._snizeObserved = true;
      mobileInput.addEventListener('input', updateHasQuery);
      mobileInput.addEventListener('change', updateHasQuery);
    } else {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (isSearchUiOpen()) close();
    else if (awaitingSnizeMount) cancelAwaitingScript();
  });

  document.addEventListener('click', function(e) {
    if (!isSearchUiOpen()) return;
    if (Date.now() < suppressOutsideCloseUntil) return;
    if (root.contains(e.target)) return;
    if (clickEventInsideSnizeOverlay(e)) return;
    close();
  });

  window.addEventListener('resize', function() {
    var w = window.innerWidth;
    if (w === lastResizeInnerWidth) return;
    lastResizeInnerWidth = w;
    if (!isSearchUiOpen()) return;
    if (window.matchMedia('(max-width: 768px)').matches) close();
  });
})();
